import React from "react";
import "./Menu.css";
import RegularMenu from "../Regular/RegularMenu";
import LeftNav from "../../components/LeftNav/LeftNav";

const Menu = () => {
  return (
    <div className="menu-wrapper">
      {/* This structure is correct */}
      <div className="left-nav-container">
        <LeftNav />
      </div>

      <div className="menu-content">
        <RegularMenu />
      </div>
    </div>
  );
};

export default Menu;